var map = {
	"./de/btn-view.png": "XoWD",
	"./en/btn-view.png": "SfID",
	"./es/btn-view.png": "q0zp",
	"./fr/btn-view.png": "Sk/L",
	"./ja/btn-view.png": "zLuI",
	"./ko/btn-view.png": "ebjy",
	"./pt/btn-view.png": "1WtS",
	"./ru/btn-view.png": "rPvk",
	"./tc/btn-view.png": "XESI",
	"./th/btn-view.png": "OQc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UY36";